import {productConfigIterator} from 'components/customer/Product/helpers/productConfigIterator';
import {GenericObject} from 'components/customer/Product/entity';
import {MATERIAL_NAMES} from 'components/customer/Materials/helper/constants';
import {cloneDeep} from 'lodash';
import {FIELD_TYPES} from 'shared/components/Forms/Field';
import {isNumericField} from 'shared/validator';
import {Structure} from 'components/customer/Product/entity/Structure';
import {Drawer} from 'components/customer/Product/entity/Drawer';

export const getInitialValues = (productDetails: Structure[]) => {
    const materialNames = Object.values(MATERIAL_NAMES);
    const materials = materialNames.reduce(
        (acc, cur) => ((acc[cur] = -1), acc),
        {}
    );
    const initialValues: GenericObject = cloneDeep(materials);

    // CREATE INITIAL VALUES FROM productDetails.productConfig then check if productData exists > true map saved values > false do nothing
    const configIterator = productConfigIterator(productDetails);

    let config;
    while ((config = configIterator.next())) {
        if (typeof config.value === 'undefined') break;

        const {field, fieldset} = config.value;

        if (
            field.name === 'drawer_runner_specs' &&
            field.options.hasHeightFields
        ) {
            if (fieldset?.options?.innerDrawer) {
                continue;
            }

            initialValues['drawers'] = [] as Drawer[];

            for (let i = 0; i < fieldset.quantity; i++) {
                initialValues['drawers'].push({
                    [field.name]: '',
                    [field.options.drawerTypeFieldName]: -1,
                    [field.options.drawerStyleFieldName]: 1,
                    [field.options.drawerHeightFieldName]: 0,
                } as Drawer);
            }
        } else if (field.name === 'cabinet_cover_void') {
            initialValues['cabinet_cover_void'] = false;
        } else {
            let fieldValue = field['value'];

            if (fieldValue == null) {
                switch (field.type) {
                    case FIELD_TYPES.BOOLEAN:
                        fieldValue = true;
                        break;

                    case FIELD_TYPES.SIZE:
                        fieldValue = 0;
                        break;

                    case FIELD_TYPES.HINGE_STYLE: // remove this later
                        fieldValue = 0;
                        break;
                }
            }

            initialValues[field['name']] = isNumericField(field.type)
                ? fieldValue
                    ? fieldValue
                    : 0
                : fieldValue;

            if (field.hasOwnProperty('options')) {
                Object.keys(field.options).forEach((key) => {
                    if (key.endsWith('Name')) {
                        const fieldName = field.options[String(key)] as string;
                        initialValues[String(fieldName)] = -1;
                    }
                });
            }
        }
    }

    return initialValues;
};
